import React from 'react';

import { FormComponent } from 'components';
import { SearchCollectionsFilterType } from 'types';

interface Props {
  filter: SearchCollectionsFilterType;
  handleFilter: (filter: SearchCollectionsFilterType) => void;
}

function Filter({ handleFilter }: Props) {
  return (
    <FormComponent.Form submit={handleFilter}>
      <FormComponent.SearchInput
        name="title"
        placeholder="타이틀로 검색해주세요"
      />
    </FormComponent.Form>
  );
}

export default Filter;
